import { Injectable } from '@angular/core';
import { DefaultPersistenceResultHandler, EntityAction } from '@ngrx/data';
import { Action } from '@ngrx/store';

// https://github.com/ngrx/platform/blob/master/projects/ngrx.io/content/guide/data/entity-metadata.md
// https://stackoverflow.com/questions/57530663/ngrx-data-how-can-i-write-custom-reducers-to-handle-endpoint-returning-multiple
// https://stackoverflow.com/questions/62828590/how-to-extend-custom-entity-collection-reducers-in-ngrx-data
// https://stackoverflow.com/questions/60256840/how-to-extend-ngrx-data-with-entity-effects
// https://stackoverflow.com/questions/60543031/overwriting-handlesuccess-of-ngrx-defaultpersistenceresulthandler
// https://github.com/ngrx/platform/issues/2434

// For entities including a queryFilter object (in additionalCollectionState).
// The data from the backend should include the filter settings used to provide the data
// and this handler will update the state with queryFilter from backend
@Injectable() // Provided in EntityModule
export class WebSocketPersistenceResultHandler extends DefaultPersistenceResultHandler {
    handleSuccess(originalAction: EntityAction): (data: any) => Action {
        const actionHandler = super.handleSuccess(originalAction);

        return (data: any) => {
            const action = actionHandler(data);
            // Initially, we needed to move queryFilter from data and add to data.payload but it seems not necessary
            // This is now all handled in the queryManySuccess() reducer method

            return action;
        };

    }
}
